import { render } from "./RichMenuPreviewModal.vue?vue&type=template&id=1630a124&scoped=true"
import script from "./RichMenuPreviewModal.vue?vue&type=script&lang=ts"
export * from "./RichMenuPreviewModal.vue?vue&type=script&lang=ts"

import "./RichMenuPreviewModal.vue?vue&type=style&index=0&id=1630a124&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1630a124"

export default script
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QToolbar,QToolbarTitle,QBtn,QCardSection,QSelect,QIcon});qInstall(script, 'directives', {ClosePopup});
